import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Body } from './Body';
import { Button } from './Button';
import { PickerModal } from './PickerModal';
export const Picker = ({ className, options, defaultValues, user, onChange, onRegisterWebhook }) => {
    const [open, setOpen] = useState(false);
    const [selectedValues, setSelectedValues] = useState(defaultValues);
    const handleToggleModal = () => {
        setOpen((prevState) => !prevState);
    };
    const handleSubmit = (values) => {
        setOpen(false);
        setSelectedValues(values);
        onChange(values);
    };
    const handleClearSelection = () => {
        setSelectedValues([]);
        onChange([]);
    };
    return _jsxs(_Fragment, { children: [_jsx(Button, { className: className, amount: selectedValues.length, open: open, onToggleModal: handleToggleModal, onClearSelection: handleClearSelection }), !open ? null : _jsx(PickerModal, { onToggleModal: handleToggleModal, children: _jsx(Body, { options: options, defaultValues: selectedValues, user: user, onRegisterWebhook: onRegisterWebhook, onSubmit: handleSubmit }) })] });
};
